'use strict';

var _ = require('lodash');
var SystemStatusInterfaceStatusFilterByEventFrequencyFactory = function SystemStatusInterfaceStatusFilterByEventFrequencyFactory(DataFilter, currentStateCriteriaService) {
  function SystemStatusInterfaceStatusFilterByEventFrequency() {
    DataFilter.call(this, ['system-status-interface-status-mode'], 'system-status-interface-status', 3);
  }
  SystemStatusInterfaceStatusFilterByEventFrequency.constructor = SystemStatusInterfaceStatusFilterByEventFrequency;
  SystemStatusInterfaceStatusFilterByEventFrequency.prototype = Object.create(DataFilter.prototype);
  function createFilters(rules) {
    var allOptions = ['Hourly', 'Daily', 'Weekly', 'Monthly'];
    return _.reduce(rules, function (result, rule) {
      if (rule.field === 'eventFrequency') {
        if (rule.operator === '=') {
          result = _.union(result, _.intersection(rule.leftOperand, allOptions));
        } else {
          result = _.union(result, _.difference(allOptions, rule.leftOperand));
        }
      }
      return result;
    }, []);
  }
  SystemStatusInterfaceStatusFilterByEventFrequency.prototype.filter = function (data) {
    var searchCriteria = currentStateCriteriaService.getSearchCriteria();
    var filter = createFilters(searchCriteria.rules);
    if (!_.size(filter)) {
      return data;
    }
    return DataFilter.prototype.filter(data, filter, 'frequency');
  };
  return SystemStatusInterfaceStatusFilterByEventFrequency;
};
SystemStatusInterfaceStatusFilterByEventFrequencyFactory.$inject = ['DataFilterFactory', 'CurrentStateCriteriaService'];
module.exports = SystemStatusInterfaceStatusFilterByEventFrequencyFactory;